export default __webpack_public_path__ + "static/media/twitter.28b4dce4.png";